import axiosInstance from "../app/axios";
import { BannerDTO } from "../components/banner/list";

interface PaginatedBannerProps {
  page: number;
  take: number;
  status?: boolean;
}

interface ChangeStatusProps {
  id: number;
  status: boolean;
}

export const getPaginatedBanners = async ({
  page,
  take,
  status,
}: PaginatedBannerProps) => {
  const result = await axiosInstance.get(
    `banners?page=${page}&take=${take}${status !== undefined ? `&status=${status}` : ""
    }`,
  );
  return result.data;
};

export const updateBanner = async (id: number, banner: BannerDTO) => {
  const result = await axiosInstance.put(`banners/${id}`, banner);
  return result.data;
};

export const createBanner = async (formData: FormData) => {
  const result = await axiosInstance.post("banners", formData);
  return result.data;
};

export const changeStatus = async ({ id, status }: ChangeStatusProps) => {
  const result = await axiosInstance.post(`banners/change-status/${id}`, {
    status,
  });
  return result.data;
};
